module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-00.2.6f6c793f.jpg";